// Fallback for a rolling deployment while an older API serves public config.
export const DEFAULT_META_GRAPH_VERSION = "v26.0";

export function resolveMetaGraphVersion(value) {
  const version = value ?? DEFAULT_META_GRAPH_VERSION;
  if (typeof version !== "string" || !/^v\d+\.\d+$/.test(version)) throw Error("Invalid Meta Graph API version");
  return version;
}
